import SEO from '../../components/SEO';
import { Arrow } from '../../components/Section';
import { services, site } from '../../data/site';
import { waLink } from '../../components/Layout';
import { Link } from 'react-router-dom';

import MilestoneTimeline from './MilestoneTimeline';

export default function Home(){
  return <div className="home-premium">
    <SEO title="Solusi Aman — Independent Security & Engineering" description="Offensive security and secure software engineering for modern web and mobile applications." canonical={site.domain}/>

    <section className="hp-hero container" aria-labelledby="home-title">
      <div className="hp-hero-copy">
        <p className="hp-overline">INDEPENDENT SECURITY & ENGINEERING PARTNER</p>
        <h1 id="home-title">We Build. We Break. <span>We Secure.</span></h1>
        <p className="hp-intro">Independent security testing and secure engineering for web and mobile applications. Build with confidence, backed by practical insight.</p>
        <div className="hp-actions">
          <a className="button" href={waLink(services[0].message)} target="_blank" rel="noopener noreferrer">Start a Conversation <Arrow/></a>
          <Link className="button light" to="/layanan">View Services</Link>
        </div>
      </div>
      <div className="hp-hero-art" aria-hidden="true">
        <img src="/assets/hero-gears-optimized.webp" width="619" height="1100" alt="" decoding="async" fetchPriority="high" />
        <div className="hp-art-fade"/>
        <div className="hp-art-label hp-art-label-top">SECURE<br/>BUILD<br/>IMPROVE</div>
        <div className="hp-art-label hp-art-label-bottom">BETTER SOFTWARE<br/>SAFER BUSINESS</div>
      </div>
    </section>

    <section className="hp-section container" aria-labelledby="home-services-title">
      <header className="hp-section-head">
        <div>
          <p className="hp-overline">OUR SERVICES</p>
          <h2 id="home-services-title">What We Do</h2>
        </div>
        <p>Practical security testing and software engineering for web and mobile products.</p>
        <Link to="/layanan" className="hp-section-link">All Services <Arrow/></Link>
      </header>

      <div className="hp-service-grid hp-service-grid-minimal">
        {services.map((service,index)=><article key={service.id} className="hp-service-card hp-service-card-minimal">
          <div className="hp-service-main hp-service-main-minimal">
            <h3>{index===0?'Offensive Security & Pentesting':'Secure Software Development'}</h3>
            <p>{index===0
              ? 'Find exploitable risks early through focused security assessments and clear remediation guidance.'
              : 'Build reliable web and mobile applications with secure architecture and maintainable code.'}
            </p>
            <div className="hp-service-divider" aria-hidden="true"/>
            <ul>
              {service.bullets.map((bullet)=><li key={bullet}>{bullet}</li>)}
            </ul>
            <a href={waLink(service.message)} target="_blank" rel="noopener noreferrer">Learn More <Arrow/></a>
          </div>
        </article>)}
      </div>
    </section>

    <section className="hp-section container" aria-labelledby="home-process-title">
      <header className="hp-section-head hp-section-head-process">
        <div>
          <p className="hp-overline">OUR PROCESS</p>
          <h2 id="home-process-title">How We Work</h2>
        </div>
        <p>A focused process from first discussion to practical delivery.</p>
        <p className="hp-head-note">Clear scope. Useful findings. Better outcomes.</p>
      </header>
      <MilestoneTimeline />
    </section>

    <section className="hp-section container" aria-labelledby="home-about-title">
      <div className="hp-about-grid hp-about-grid-map">
        <div className="hp-about-copy">
          <p className="hp-overline">ABOUT US</p>
          <h2 id="home-about-title">About Solusiaman</h2>
          <p>Independent security and software engineering for modern digital products.</p>
          <p>We turn technical findings into clear next steps and dependable software.</p>
          <Link to="/tentang" className="button light">About Us <Arrow/></Link>
        </div>

        <div className="hp-google-map" aria-label="Google Maps — Bintaro Plaza, Pondok Karya, Pondok Aren, Tangerang Selatan">
          <iframe
            title="Bintaro Plaza on Google Maps"
            src="https://www.google.com/maps?q=-6.271901%2C106.7416848&z=17&output=embed"
            width="100%"
            height="100%"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
          <a className="hp-map-open" href="https://www.google.com/maps/place/Bintaro+Plaza/@-6.271901,106.7416848,17z" target="_blank" rel="noopener noreferrer">Open in Google Maps <Arrow/></a>
        </div>
      </div>
    </section>

    <section className="hp-conversation container" aria-labelledby="home-contact-title">
      <div>
        <p className="hp-overline">LET’S TALK</p>
        <h2 id="home-contact-title">Discuss your security<br/>or development needs.</h2>
      </div>
      <p>Tell us what you need to test, build, or improve.</p>
      <Link to="/kontak" className="button">Start a Conversation <Arrow/></Link>
    </section>
  </div>;
}
